// Actions
export const CALCULATOR_IS_LOADING = 'CALCULATOR_IS_LOADING';
export const CALCULATOR_HAS_ERROR = 'CALCULATOR_HAS_ERROR';
export const CALCULATOR_UPDATE = 'CALCULATOR_UPDATE';

// Default State
const initialState = {
    isLoading: false,
    hasError: false,
    pagination: false,
    paginationHasSkip: false,
    paginationPreviousRoute: false
};

export const updatePagination = dispatch => (isActive) => {
    dispatch({
        type: CALCULATOR_UPDATE,
        response: {
            pagination: isActive
        }
    });
};

export const updatePaginationSkip = dispatch => (hasSkip) => {
    dispatch({
        type: CALCULATOR_UPDATE,
        response: {
            paginationHasSkip: hasSkip
        }
    });
};

export const updatePaginationPreviousRoute = dispatch => (route) => {
    dispatch({
        type: CALCULATOR_UPDATE,
        response: {
            paginationPreviousRoute: route
        }
    });
};

export default (state = initialState, action = {}) => {
    const {
        type,
        response,
        isLoading,
        hasError
    } = action;

    switch (type) {
        case CALCULATOR_IS_LOADING:
            return {
                ...state,
                isLoading
            };
        case CALCULATOR_HAS_ERROR:
            return {
                ...state,
                hasError
            };
        case CALCULATOR_UPDATE:
            return {
                ...state,
                ...response
            };
        default:
            return state;
    }
}
